var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-auditor" },
    [
      _vm.auditor && _vm.auditor.fileFlow
        ? [
            _vm._l(_vm.auditor.fileFlow, function(item, i) {
              return [
                _c(
                  "div",
                  { key: "fileFlow_title_" + i, staticClass: "title" },
                  [
                    _vm._v(
                      "\n        文件审批" +
                        _vm._s(_vm.auditor.fileFlow.length > 1 ? i + 1 : "") +
                        "\n        "
                    )
                  ]
                ),
                _c("div", { key: "fileFlow_" + i, staticClass: "content" }, [
                  _c("div", { key: i, staticClass: "desc" }, [
                    _c("p", [
                      _c("span", { staticClass: "user-tilte-color" }, [
                        _vm._v("申请人：")
                      ]),
                      _c("span", [_vm._v(_vm._s(item.createUser))])
                    ]),
                    _c("p", { staticClass: "userName" }, [
                      _c("span", [_vm._v(_vm._s(item.taskCreateTime))])
                    ])
                  ]),
                  _c("p", { staticClass: "tit" }, [
                    _vm._v(
                      "\n          共" +
                        _vm._s(item.nodes.length) +
                        "方\n          "
                    ),
                    _c("span", {
                      style: {
                        color: _vm.colorStatus,
                        float: "right",
                        marginRight: "20px"
                      }
                    })
                  ])
                ]),
                _vm._l(item.nodes, function(node, j) {
                  return [
                    _c(
                      "div",
                      { key: "fileFlow_" + i + j, staticClass: "content" },
                      [
                        _c(
                          "div",
                          { staticClass: "obj-box" },
                          _vm._l(node.taskList, function(v, index) {
                            return _c(
                              "div",
                              { key: index, staticClass: "obj" },
                              [
                                v.userId === _vm.dingTalkUserId
                                  ? [
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            effect: "dark",
                                            content: v.name + "(我)",
                                            placement: "bottom"
                                          }
                                        },
                                        [
                                          _c("div", { staticClass: "user" }, [
                                            _c("span", {
                                              staticClass: "el-icon-user-solid"
                                            })
                                          ])
                                        ]
                                      )
                                    ]
                                  : [
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            effect: "dark",
                                            content: v.name,
                                            placement: "bottom"
                                          }
                                        },
                                        [
                                          _c("div", { staticClass: "user" }, [
                                            _c("span", {
                                              staticClass: "el-icon-user-solid"
                                            })
                                          ])
                                        ]
                                      )
                                    ],
                                _c("div", { staticClass: "obj-other" }, [
                                  _c("p", { staticClass: "userName" }, [
                                    _vm._v(_vm._s(v.name))
                                  ]),
                                  _vm.comstatus(v) === 1
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "status text-color-green"
                                        },
                                        [
                                          _vm._v(
                                            "\n                  已同意\n                "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.comstatus(v) === 2
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "status text-color-red"
                                        },
                                        [
                                          _vm._v(
                                            "\n                  已驳回\n                "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.comstatus(v) === 0
                                    ? _c("div", { staticClass: "status" }, [
                                        _vm._v("未审批")
                                      ])
                                    : _vm._e(),
                                  v.finishTime
                                    ? _c("div", { staticClass: "time" }, [
                                        _vm._v(_vm._s(v.finishTime))
                                      ])
                                    : _vm._e()
                                ]),
                                _vm._v("\n                \n              "),
                                _vm.comstatus(v) === 0
                                  ? _c(
                                      "el-button",
                                      {
                                        staticClass: "approver-bth-sty",
                                        attrs: {
                                          plain: "",
                                          type: "primary",
                                          size: "small"
                                        },
                                        on: { click: _vm.urgeForTrial }
                                      },
                                      [_vm._v("催审")]
                                    )
                                  : _vm._e()
                              ],
                              2
                            )
                          }),
                          0
                        )
                      ]
                    )
                  ]
                })
              ]
            })
          ]
        : _vm._e(),
      _c("ding-sign-approve", {
        attrs: { signAuditor: _vm.auditor.sealFlow, singInfo: _vm.applyInfo }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-97297b58", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-97297b58","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/auditDetail/dingNew.vue
// module id = beyH
// module chunks = 13 14 17 26 32